import styled, { css } from 'styled-components';
import TableRow from '@material-ui/core/TableRow';

export const CustomTableBodyRow = styled(TableRow)`
  &:nth-of-type(even) {
    background: #f7f7f7;
  }
  &:last-child {
    td {
      border-bottom: none;
    }
  }
  ${props =>
    props.clickable &&
    css`
      pointer-events: all;
    `};
  ${props =>
    props.hoverable &&
    css`
      cursor: pointer;
      &:hover {
        background: #000;
        td {
          color: #fff;
        }
      }
    `};
  .no-m {
    @media (max-width: 768px) {
      display: none;
    }
  }
  .no-l {
    @media (max-width: 1024px) {
      display: none;
    }
  }
`;
